import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { useMessageList } from '../../../messages/composables/use-message-list';
import { InstallerMessage, InstallerMessageContent, MessageId } from '../../../messages/models/installer-message';
import { NotificationResource } from '../../../notifications/resource/notification-resource';
import { useToaster } from '../../composables/use-toaster';
import { UISocketDataMessage } from '../../models/UISocket';
import { SocketAction, SocketActionHandler } from '../SocketActionHandler';

export type NewInstallerMessageContent = { id: MessageId } & InstallerMessageContent;

export interface UISocketNewInstallerMessageMessage extends UISocketDataMessage {
    notification: NewInstallerMessageContent;
}

function installerMessageFromEvent(event: UISocketNewInstallerMessageMessage): InstallerMessage {
    const notification = event.notification;
    return {
        id: notification.id,
        date: notification.date,
        read: false,
        notification,
    };
}

@Injectable()
export class NewInstallerMessageHandler implements SocketActionHandler {
    readonly action: SocketAction = 'newInstallerNotification';

    private readonly router = inject(Router);
    private readonly translate = inject(TranslateService);
    private readonly toaster = useToaster();
    private readonly messageList = useMessageList();
    private readonly notifications = inject(NotificationResource);

    handle(event: UISocketNewInstallerMessageMessage): void {
        const receivedMessage = this.messageList.addMessage(installerMessageFromEvent(event));
        this.notifications.reload();
        this.toaster.info({
            title: this.translate.instant('INSTALLER_NEW_MESSAGE_RECEIVED_TITLE'),
            message: receivedMessage?.title ?? '',
            onClick: () => this.router.navigate(['/notifications']),
            duration: 3000,
        });
    }
}
